import { createFileRoute } from '@tanstack/react-router';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';
import { SettlementStatisticsConverterListPage } from '@/pages/settlement-statistics-converter/ui/SettlementStatisticsConverterListPage';
import { routeValidateQuerySearch } from '@/shared/lib/route';

/**
 * 決算統計コンバータールート
 *
 * 検索パラメータ:
 * - page: ページ番号
 * - page_size: ページサイズ
 */
export const Route = createFileRoute('/_protected/settlement-statistics-converter/')({
  component: SettlementStatisticsConverterListPage,
  beforeLoad: () => {
    requireReleaseFlag('settlement_statistics_converter');
  },
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      defaultValues: undefined,
    }),
});
